import { queryOptions } from '@tanstack/react-query';
import HttpClient from '../../Api/HttpClient';
import { randomString } from '../../components/Utils';

function handle401(apiCall) {
  return async () => {
    try {
      const response = await apiCall();

      return response;
    } catch (e) {
      if (e.status === 401) {
        return null;
      } else {
        throw e;
      }
    }
  };
}

export const singleCardQuery = (cardId) =>
  queryOptions({
    queryKey: ['card', cardId],
    queryFn: handle401(async () => {
      if (cardId === null) {
        return null;
      }

      const { data } = await HttpClient.fetchSingleCard({
        card_id: cardId,
        maap_task: true,
      });

      return data[0];
    }),
  });

export const projectQuery = (projectId) =>
  queryOptions({
    queryKey: ['project', projectId],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.projectLiteView({ board: projectId });

      return data[0];
    }),
  });

export const contentsQuery = (projectId) =>
  queryOptions({
    queryKey: ['contents', projectId],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.getContents({
        fetchContent: false,
        id: projectId,
      });

      return data;
    }),
  });

export const vendorQuery = () =>
  queryOptions({
    queryKey: ['vendor'],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.vendorDetails();

      return data;
    }),
  });

export const watchersQuery = (taskId) =>
  queryOptions({
    queryKey: ['watchers', taskId],
    queryFn: handle401(async () => {
      if (taskId === null) {
        return [];
      }

      const { data } = await HttpClient.getWatchers({ id: taskId });

      return data;
    }),
  });

export const loader = (queryClient) => async (opts) => {
  const url = new URL(opts.request.url);
  const taskId = url.searchParams.get('task_id');
  const projectId = url.searchParams.get('board');
  await queryClient.ensureQueryData(projectQuery(projectId));
  await queryClient.ensureQueryData(contentsQuery(projectId));
  await queryClient.ensureQueryData(vendorQuery());
  if (taskId !== '0') {
    await queryClient.ensureQueryData(singleCardQuery(taskId));
    await queryClient.ensureQueryData(watchersQuery(taskId));
  }

  return { taskId, projectId };
};

export const addWatcher = ({ onSuccess }) => {
  return {
    mutationFn: async ({ firstName, lastName, email, buyerCompany, taskId }) => {
      let formData = new FormData();
      formData.append('first_name', firstName);
      formData.append('last_name', lastName);
      formData.append('email', email);
      formData.append('is_active', 'True');
      formData.append('is_staff', 'True');
      formData.append('password', randomString(8));

      if (buyerCompany) {
        formData.append('is_staff', 'False');
        formData.append('role', 'buyer');
        formData.append('user_type', 'light');
        formData.append('buyer_company', buyerCompany.id);
      }

      let userId;
      try {
        const { data } = await HttpClient.addUser({
          data: formData,
        });

        userId = data.user_id;
      } catch (err) {
        if (err.response && err.response.status === 409) {
          userId = err.response.data.existing_user_id;
        } else {
          throw err;
        }
      }

      const watcherFormData = new FormData();
      watcherFormData.append('card', taskId);
      watcherFormData.append('user_id', userId);
      const { data } = await HttpClient.postWatchers({
        data: watcherFormData,
      });

      return data;
    },
    onSuccess,
  };
};
